<template>
  <Card id="sale-card" :style="cardStyle">
    <template v-slot:content>
      <div class="grid-container">
        <div class="buyer-name">
          <span class="sale-card-field">
            <span class="material-icons">person</span>
            <p
              class="text-field-overflow"
              v-tooltip.top="sale.buyer?.name || ''"
            >
              {{ sale.buyer?.name || '-' }}
            </p>
          </span>
        </div>
        <div class="bovine-count">
          <span class="sale-card-field">
            <span><IconBovine style="margin-top: 5px" /></span>
            <p v-if="sale.bovines.length > 1">
              {{ sale.bovines.length }} Bovinos
            </p>
            <p v-else>{{ sale.bovines.length }} Bovino</p>
          </span>
        </div>
        <div class="buyer-document">
          <span class="sale-card-field">
            <span class="material-icons">assignment</span>
            <p>
              <span v-if="sale.buyer?.document">
                {{
                  sale.buyer?.document.length === 11
                    ? $formatCPF(sale.buyer?.document)
                    : $formatCNPJ(sale.buyer?.document)
                }}
              </span>
              <span v-else> - </span>
            </p>
          </span>
        </div>
        <div class="invoice">
          <span class="sale-card-field">
            <span><IconInvoice style="margin-top: 5px" /></span>
            <p>{{ sale.invoice || '-' }}</p>
          </span>
        </div>
        <div class="bovine-summary">
          <span class="sale-card-field">
            <BovineTypeSummary
              style="margin-top: 5px"
              :bovines="bovines"
              :inactive="sale.statusId === 3"
            ></BovineTypeSummary>
          </span>
        </div>
        <div class="total-weight">
          <span class="sale-card-field">
            <span>
              <IconWeight style="margin-top: 5px" />
            </span>
            <p>
              {{ sale.totalWeight ? $toDecimal(sale.totalWeight) : '-' }}
            </p>
          </span>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import IconWeight from '../../../components/icon/IconWeight.vue';
import IconBovine from '../../../components/icon/IconBovine.vue';
import IconInvoice from '../../../components/icon/IconInvoice.vue';
import BovineTypeSummary from '../../../components/BovineTypeSummary.vue';

export default {
  name: 'SaleCard',
  components: {
    IconBovine,
    IconInvoice,
    BovineTypeSummary,
    IconWeight,
  },
  props: {
    sale: Object,
  },
  computed: {
    isInactive() {
      return this.sale?.statusId === 3;
    },
    cardStyle() {
      if (this.isInactive) {
        return { backgroundColor: 'rgba(229, 229, 229, 0.5)' };
      }
      return {};
    },
    bovines() {
      return this.sale.bovines.map((saleBovine) => saleBovine.bovine);
    },
  },
};
</script>

<style scoped>
#sale-card >>> .p-card-content {
  padding: 0 !important;
}
.sale-card-field span {
  padding-right: 10px;
}
.sale-card-field p {
  display: inline-block;
  vertical-align: top;
  padding-top: 2px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 0.5em 1em;
  grid-template-areas:
    'buyer-name buyer-name'
    'buyer-document buyer-document'
    'invoice bovine-count'
    'total-weight bovine-summary';
}

@media (min-width: 600px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 0.5em 1em;
    grid-template-areas:
      'buyer-name invoice bovine-count'
      'buyer-document total-weight bovine-summary';
  }
}

@media (min-width: 960px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 0.5em 1em;
    grid-template-areas:
      'buyer-name invoice bovine-count'
      'buyer-document total-weight bovine-summary';
  }
}

.buyer-name {
  grid-area: buyer-name;
}

.date {
  grid-area: date;
}

.bovine-count {
  grid-area: bovine-count;
}

.total-value {
  grid-area: total-value;
}

.buyer-document {
  grid-area: buyer-document;
}

.invoice {
  grid-area: invoice;
}

.bovine-summary {
  grid-area: bovine-summary;
}

.total-weight {
  grid-area: total-weight;
}
</style>
